import Field from "../../components/Field";
import CountrySelectField from './CountrySelectField'
import React from 'react'
import t from '../../translate'
import { useFormikContext } from 'formik'
import PassphotoField from '../../components/PassphotoField'


function Student ({ id, countries }) {
  return <div className={'student'}>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <label
          htmlFor={`data.personal.information.students.${id}.firstName`}>{t(
          'data.personal.information.firstName')}*</label>
        <Field type={'text'}
               id={`data.personal.information.students.${id}.firstName`}
               name={`data.personal.information.students.${id}.firstName`}/>
      </div>
      <div className={'form-col'}>
        <label
          htmlFor={`data.personal.information.students.${id}.lastName`}>{t(
          'data.personal.information.lastName')}*</label>
        <Field type={'text'}
               id={`data.personal.information.students.${id}.lastName`}
               name={`data.personal.information.students.${id}.lastName`}/>
      </div>
    </div>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={`data.personal.information.students.${id}.birthday`}>{t(
          'data.personal.information.birthday')}*</label>
        <Field type="date" className={"small-field"} id={`data.personal.information.students.${id}.birthday`}
               name={`data.personal.information.students.${id}.birthday`} required/>
      </div>
      <div className={'form-col'}>
        <label>{t('data.personal.information.gender.label')}*</label>
        <div className={'radio-inline'}>
          <div className="form-radio">
            <Field
              id={`data.personal.information.students.${id}.gender.female`}
              name={`data.personal.information.students.${id}.gender`}
              type="radio"
              value={'f'}
            />
            <label htmlFor={`data.personal.information.students.${id}.gender.female`}
                   className="form-radio-label">
              {t('data.personal.information.gender.female')}
            </label>
          </div>
          <div className="form-radio">
            <Field
              id={`data.personal.information.students.${id}.gender.male`}
              name={`data.personal.information.students.${id}.gender`}
              type="radio"
              value={'m'}
            />
            <label htmlFor={`data.personal.information.students.${id}.gender.male`}
                   className="form-radio-label">
              {t('data.personal.information.gender.male')}
            </label>
          </div>
          <div className="form-radio">
            <Field
              id={`data.personal.information.students.${id}.gender.divers`}
              name={`data.personal.information.students.${id}.gender`}
              type="radio"
              value={'d'}
            />
            <label htmlFor={`data.personal.information.students.${id}.gender.divers`}
                   className="form-radio-label">
              {t('data.personal.information.gender.divers')}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={`data.personal.information.students.${id}.birthCountry`}>{t(
          'data.personal.information.birthCountry')}*</label>
        <CountrySelectField type="text"
                      id={`data.personal.information.students.${id}.birthCountry`}
                      name={`data.personal.information.students.${id}.birthCountry`}
                      countries={countries}
                      required={true}/>
      </div>
      <div className={'form-col'}>
        <label htmlFor={`data.personal.information.students.${id}.birthCity`}>{t(
          'data.personal.information.birthCity')}*</label>
        <Field type="text" id={`data.personal.information.students.${id}.birthCity`}
               name={`data.personal.information.students.${id}.birthCity`} required/>
      </div>
    </div>
  </div>
}

function MultipleFields ({countries}) {
  let { values, setFieldValue } = useFormikContext()
  let students = []
  if(values && values.data && values.data.personal.information && values.data.personal.information.students) {
    students = values.data.personal.information.students
  }
  let studentNumber = students.length > 1 ? students.length : 1
  let canRemoveStudent = studentNumber > 1

  function addStudent () {
    students.push({})
    setFieldValue('data.personal.information.students', students)
  }

  function removeStudent () {
    if (canRemoveStudent) {
      students.pop()
      setFieldValue('data.personal.information.students', students)
    }
  }

  const labelDelete = t('remove')

  return <>
    <div className={'students'}>
      <div className={'form-col'}>
        <label
          htmlFor={`data.personal.information.company`}>{t(
          'data.personal.information.company')}*</label>
        <Field type={'text'}
               id={`data.personal.information.company`}
               name={`data.personal.information.company`}/>
      </div>
      {((studentNumber) => {
        let students = []
        for (let i = 0; i < studentNumber; i++) {
          students.push(<Student key={i} id={i} countries={countries}/>)
        }
        return students
      })(studentNumber)}
    </div>
    <button className={'button'} type={'button'} onClick={addStudent}>{t(
      'add')}</button>
    {canRemoveStudent && <button type={'button'} className={'button'}
                                  onClick={removeStudent}>{labelDelete}</button>}
  </>
}

function SingleFields ({countries, errors}) {

  function preventCopyPaste(e) {
    // Prevent Ctrl+C, Ctrl+V, Ctrl+X
    if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'v' || e.key === 'x')) {
        e.preventDefault();
        return false;
    }
    // Prevent right click
    if (e.type === 'contextmenu') {
        e.preventDefault();
        return false;
    }
    return true;
  }
  return <>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.information.title'}>{t(
          'data.personal.information.title.label')}</label>
        <div className={'select-wrapper small-field'}>
          <Field as="select" name="data.personal.information.title"
                 id="data.personal.information.title">
            <option value="">---</option>
            <option value="dr">{t('data.personal.information.title.dr.label')}</option>
            <option value="prof">{t('data.personal.information.title.prof.label')}</option>
            <option value="profdr">
              {t('data.personal.information.title.profdr.label')}
            </option>
          </Field>
        </div>
      </div>
    </div>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.information.firstName'}>{t(
          'data.personal.information.firstName')}*</label>
        <Field type="text" id="data.personal.information.firstName"
               name="data.personal.information.firstName" required/>
      </div>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.information.lastName'}>{t(
          'data.personal.information.lastName')}*</label>
        <Field type="text" id="data.personal.information.lastName"
               name="data.personal.information.lastName" required/>
      </div>
    </div>
    
    <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.information.birthday'}>{t(
          'data.personal.information.birthday')}*</label>
        <Field type="date" className={"small-field"} id="data.personal.information.birthday"
               name="data.personal.information.birthday" required/>
      </div>
      <div className={'form-col'}>
        <label>{t('data.personal.information.gender.label')}*</label>
        <div className={'radio-inline'}>
          <div className="form-radio">
            <Field
              id={'data.personal.information.gender.female'}
              name="data.personal.information.gender"
              type="radio"
              value={'f'}
            />
            <label htmlFor={'data.personal.information.gender.female'}
                   className="form-radio-label">
              {t('data.personal.information.gender.female')}
            </label>
          </div>
          <div className="form-radio">
            <Field
              id={'data.personal.information.gender.male'}
              name="data.personal.information.gender"
              type="radio"
              value={'m'}
            />
            <label htmlFor={'data.personal.information.gender.male'}
                   className="form-radio-label">
              {t('data.personal.information.gender.male')}
            </label>
          </div>
          <div className="form-radio">
            <Field
              id={'data.personal.information.gender.divers'}
              name="data.personal.information.gender"
              type="radio"
              value={'d'}
            />
            <label htmlFor={'data.personal.information.gender.divers'}
                   className="form-radio-label">
              {t('data.personal.information.gender.divers')}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.information.birthCountry'}>{t(
          'data.personal.information.birthCountry')}*</label>
        <CountrySelectField type="text"
                      id="data.personal.information.birthCountry"
                      name="data.personal.information.birthCountry"
                      countries={countries}
                      required={true}/>
      </div>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.information.birthCity'}>{t(
          'data.personal.information.birthCity')}*</label>
        <Field type="text" id="data.personal.information.birthCity"
               name="data.personal.information.birthCity" required/>
      </div>
    </div>
  </>
}

export default function PersonalDataForm ({countries, errors}) {
  let { values } = useFormikContext();
  let isMultiple = false;
  let fields = <></>;

  if ("multiple" in values) {
    isMultiple = values.multiple;
  }

  if (isMultiple) {
    fields = <MultipleFields countries={countries}/>;
  } else {
    fields = <SingleFields countries={countries}/>;
  }

  return <>
    {/* <div className="form-checkbox">
      <Field
        id={`multiple`}
        type="checkbox"
        name={`multiple`}
      />
      <label htmlFor={`multiple`}>
        {t('data.personal.multiple')}
      </label>
    </div> */}
    {fields}
  </>
}
